import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["deviceData"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { transformCreateMopPayload } from './helpers/transformCreateMopPayload';
import { createMOP, updatePaymentState } from './PaymentState.actions';
import { PaymentMethodsCommandNames } from '@chegg/commerce-utils';
import { ACCOUNT_TYPE } from '../../constants/PaymentTypes';
import { doFireStatusUpdate } from '../../utils/CallbackUtils';
import { Component } from '../../constants/CallbackConstants';
import { StatusTypes } from '@chegg/commerce-utils';
import API from '../../api';
import { handleCreateMopAPIFailure } from './helpers/handleCreateMopAPIFailure';
import { handleCreateMopError } from './helpers/handleCreateMopError';
import { handleCreateMopSuccess } from './helpers/handleCreateMopSuccess';
import { shouldFireCallbackCommands } from './helpers/shouldFireCallbackCommands';
var CreateMopLogic = function CreateMopLogic(middleware) {
  return middleware.startListening({
    actionCreator: createMOP,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
        var payload, getState, dispatch, transformedPayload, _ref3, accountType, _getState, appMode, mopOnFile, payment, config, goBackMode, paymentMethods, rioNamespace, ui, paymentForm, matchedCards, _ref4, showSubmitButton, paymentType, PAYMENT_TYPE_MAP, shouldFireCallbacks, deviceData, rest, createMopPayload, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = _ref.payload;
              getState = _ref2.getState, dispatch = _ref2.dispatch;
              transformedPayload = transformCreateMopPayload(payload);
              _ref3 = transformedPayload, accountType = _ref3.accountType;
              _getState = getState(), appMode = _getState.appMode, mopOnFile = _getState.mopOnFile, payment = _getState.payment, config = _getState.config;
              goBackMode = appMode.goBackMode;
              paymentMethods = mopOnFile.paymentMethods;
              rioNamespace = config.rioNamespace, ui = config.ui, paymentForm = config.paymentForm;
              matchedCards = payment.matchedCards;
              _ref4 = ui, showSubmitButton = _ref4.showSubmitButton;
              paymentType = '';
              PAYMENT_TYPE_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ACCOUNT_TYPE.PAYPAL_TOKEN, 'Paypal:'), ACCOUNT_TYPE.APPLE_PAY, 'Apple Pay:'), ACCOUNT_TYPE.VENMO, 'Venmo:'), ACCOUNT_TYPE.CREDIT_CARD, 'Credit Card:'), ACCOUNT_TYPE.UPI, 'UPI:'), ACCOUNT_TYPE.GOOGLE_PAY, 'Google Pay:'), ACCOUNT_TYPE.BALANCE, ''), ACCOUNT_TYPE.GIFT_CODE, ''), ACCOUNT_TYPE.PLACEHOLDER, 'Placeholder:');
              if (accountType) {
                paymentType = PAYMENT_TYPE_MAP[accountType];
              }
              shouldFireCallbacks = shouldFireCallbackCommands(paymentMethods, showSubmitButton, accountType);
              dispatch(updatePaymentState({
                isLoading: true
              }));
              if (shouldFireCallbacks) {
                doFireStatusUpdate([{
                  status: StatusTypes.PENDING,
                  command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
                  payload: {
                    component: Component.PAYMENT_MODULE_LOGIC
                  }
                }]);
              }
              deviceData = transformedPayload.deviceData, rest = _objectWithoutProperties(transformedPayload, _excluded);
              createMopPayload = _objectSpread({
                deviceData: deviceData
              }, rest);
              _context.next = 20;
              return API.createMop(createMopPayload);
            case 20:
              response = _context.sent;
              if (!response.data) {
                handleCreateMopAPIFailure({
                  response: response,
                  dispatch: dispatch,
                  paymentType: paymentType,
                  rioNamespace: rioNamespace
                });
              }
              //data error from createMOP API
              else if (!response.data.mopV2) {
                handleCreateMopError({
                  response: response,
                  dispatch: dispatch,
                  matchedCards: matchedCards,
                  paymentType: paymentType,
                  rioNamespace: rioNamespace
                });
              }
              //Successful call to createMOP API
              else {
                handleCreateMopSuccess({
                  response: response,
                  dispatch: dispatch,
                  shouldFireCallbacks: shouldFireCallbacks,
                  deviceData: deviceData,
                  paymentMethods: paymentMethods,
                  goBackMode: goBackMode,
                  rioNamespace: rioNamespace,
                  paymentForm: paymentForm
                });
              }
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default CreateMopLogic;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/CreateMop.listener.js
// module id = 4384
// module chunks = 11